name: Gaai icons pack
author: Gaai
link: 
license: 
sort: name
source: ../assets/img/gaai
